<template>
  <div>
    <el-row class="table-warpper">
      <el-col :span="12" class="table-title">结构分析</el-col>
      <el-col :span="12" class="table-icon">
        <div @click="showPopup">
          <img src="../../../../static/images/screen.png" style="width:.2rem;height:.2rem">
        </div>
        <van-popup v-model="show">
          <table-screens ref="screen" v-on:childByValue="childByValue" :otherFiler="nameData" :typeData="typeData"></table-screens>
        </van-popup>
      </el-col>
    </el-row>
    <div class="curTable">
      <el-table
        ref="structureTable1"
        :span-method="objectSpanMethod"
        :data="showData"
        style="width: 100%"
        row-key="orgRiskId"
        border
        lazy
        :height="childShow ? popHeight : tableHeight"
        :load="load"
        v-loading="loading"
        @sort-change="sortProportion"
        :header-cell-class-name="handleTheadAddClass"
        :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
        class="table-itme tableList5">
        <el-table-column
          :key="Math.random()"
          prop="orgName"
          label="机构"
          sortable='custom'
          style="width: 20%"
          class="demo-table-expand">
        </el-table-column>
        <el-table-column
          :key="Math.random()"
          prop="riskTypeName"
          :label="nameData.riskTypeName"
          style="width: 20%"
          class="demo-table-expand">
        </el-table-column>
        <el-table-column
          :key="Math.random()"
          prop="reach"
          sortable='custom'
          style="width: 40%"
          :label="nameData.achievementName">
          <template slot-scope="scope">
            <span v-if="scope.row.reach !== null">{{ scope.row.reach.toString().replace(/(\d{1,3})(?=(\d{3})+$)/g,'$1,') }}</span>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column
          :key="Math.random()"
          prop="proportion"
          sortable='custom'
          style="width: 25%"
          label="占比">
          <template slot-scope="scope">
            <span v-if="scope.row.proportion !== null">{{scope.row.proportion}}%</span>
            <span v-else>--%</span>
          </template>
        </el-table-column>
      </el-table>
      <el-row>
        <el-col v-if="childShow" :span="24"><div @click="backMore(true)" class="more">返回</div></el-col>
        <!-- <el-col v-if="childShow" :span="24"><div @click="showMore" class="more">查看更多</div></el-col> -->
        <el-col v-if="!childShow" :span="24"><div @click="showMore" class="more">{{moreText}}</div></el-col>
      </el-row>
    </div>
    <div class="fixTop" v-show="isShow">
      <el-table
        ref="structureTable2"
        :span-method="objectSpanMethod"
        :data="popData"
        style="width: 100%"
        row-key="orgRiskId"
        border
        lazy
        :load="load"
        v-loading="loading"
        @sort-change="sortProportion"
        :header-cell-class-name="handleTheadAddClass"
        :height="popHeight"
        :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
        class="table-itme">
        <el-table-column
          :key="Math.random()"
          prop="orgName"
          label="机构"
          sortable='custom'
          style="width: 20%"
          class="demo-table-expand">
        </el-table-column>
        <el-table-column
          :key="Math.random()"
          prop="riskTypeName"
          :label="nameData.riskTypeName"
          style="width: 20%"
          class="demo-table-expand">
        </el-table-column>
        <el-table-column
          :key="Math.random()"
          prop="reach"
          sortable='custom'
          style="width: 40%"
          :label="nameData.achievementName">
          <template slot-scope="scope">
            <span v-if="scope.row.reach !== null">{{ scope.row.reach.toString().replace(/(\d{1,3})(?=(\d{3})+$)/g,'$1,') }}</span>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column
          :key="Math.random()"
          prop="proportion"
          sortable='custom'
          style="width: 25%"
          label="占比">
          <template slot-scope="scope">
            <span v-if="scope.row.proportion !== null">{{ scope.row.proportion }}%</span>
            <span v-else>--%</span>
          </template>
        </el-table-column>
      </el-table>
      <el-row>
        <el-col v-if="childShow" :span="24"><div @click="backMore(false)" class="more">返回</div></el-col>
        <el-col v-if="!childShow" :span="24"><div @click="back" class="more">收起</div></el-col>
      </el-row>
    </div>
    <home-commonbg class="showImg" v-if="loadFlag"></home-commonbg>
  </div>
</template>

<script>
import HomeCommonbg from '../../common/commonBg'
import TableScreens from '../../common/analyseScreen/StructureScreen'
// import axios from 'axios'
import { postAction } from '@/utils/api'
export default {
  name: 'StructureTable',
  components: {
    TableScreens,
    HomeCommonbg
  },
  props: ['timeIndex', 'dateData'],
  data () {
    return {
      tableHeight: '',
      show: false,
      moreFlag: null,
      listData: [],
      showData: [],
      isProduct: false,
      moreText: '查看更多',
      showTabledata: [],
      tableData: {},
      loading: '',
      getData: '',
      nameData: {},
      typeData: [],
      firstLevel: [], // 筛选中的一级数据
      reachObj: null,
      compareObj: null,
      selectCode: '',
      selectType: '',
      postChannel: '',
      postKind: '',
      postQuota: '',
      popData: null,
      popHeight: '',
      isShow: false,
      childTable: [],
      childShow: false,
      sortData: [],
      typeLength: '',
      typeLengthArr: [],
      curThead: '',
      sequenceOrder: null, // 表格列排序的顺序 ascending 正序 descending 倒序 null 默认
      loadFlag: false,
      totalRows: [],
      tableDataAny: [],
      pageNum: 0, // 0 结构分析首页 1 结构分析查看更多页 2 结构分析查看更多下钻页
      isInto: false // 是否为下钻 默认为 false true 为下钻
    }
  },
  methods: {
    sortProportion (column) {
      this.curThead = column.prop
      this.totalDealSortArr(column.prop, column.order)
      this.$nextTick(() => {
        if (this.$store.state.user.level === '1' && this.pageNum !== 2 && this.isShow) {
          const data = this.$refs.structureTable2.store.states.data
          let result = []
          let one = JSON.parse(JSON.stringify(this.totalRows))
          if (column.prop === 'proportion' && this.sequenceOrder !== 'null') {
            if (column.order === 'ascending') {
              one = JSON.parse(JSON.stringify(this.totalRows))
              one = one.sort((a, b) => {
                return a.proportion - b.proportion
              })
            } else if (column.order === 'descending') {
              one = JSON.parse(JSON.stringify(this.totalRows))
              one = one.sort((a, b) => {
                return b.proportion - a.proportion
              })
            }
            result = JSON.parse(JSON.stringify(one.concat(data)))
          } else {
            result = JSON.parse(JSON.stringify(this.totalRows.concat(data)))
          }
          this.$refs.structureTable2.store.states.data = this.rowSpanFormatData(result)
        }
      })
    },
    // colData判断是哪一列  flagData 判断是升序还是降序
    totalDealSortArr (colData, flagData) {
      if (this.$store.state.user.level !== '1' && !this.childShow) {
        this.sortData = JSON.parse(JSON.stringify(this.tableData))
      } else if (this.$store.state.user.level === '1' && !this.isInto) {
        // 总公司 点击查看查看更多
        this.sortData = JSON.parse(JSON.stringify(this.tableData))
      } else {
        this.sortData = JSON.parse(JSON.stringify(this.childTable))
      }
      if (colData === 'orgName') { // 选择机构列
        if (flagData === 'ascending') { // 升序
          // 如果机构列当前为升序状态 则把表格置为初始状态
          if (this.sequenceOrder === 'orgascending') {
            this.rowSpanFormatData(this.sortData) // 合并单元格
            this.sequenceOrder = 'null'
          } else {
            setTimeout(() => {
              $('.active-thead .sort-caret.ascending').css({'borderBottomColor': '#409eff'}) // 升序箭头高亮
            }, 200)
            this.rowSpanFormatData(this.sortData) // 合并单元格
            this.sequenceOrder = 'orgascending' // 标志机构排序类型
          }
        } else if (flagData === 'descending') { // 降序
          // 如果机构列当前为降序状态 则把表格置为初始状态
          if (this.sequenceOrder === 'orgdescending') {
            this.rowSpanFormatData(this.sortData) // 合并单元格
            this.sequenceOrder = 'null'
          } else {
            setTimeout(() => {
              $('.active-thead .sort-caret.descending').css({'borderTopColor': '#409eff'}) // 降序箭头高亮
            }, 200)
            // 把获取的数据按照机构分组 然后倒序排列 再把各机构组合成一个数组
            this.sortData = this.realignSortArr(this.dealSortArr(this.sortData).reverse())
            this.rowSpanFormatData(this.sortData) // 合并单元格
            this.sequenceOrder = 'orgdescending'
          }
        } else if (flagData === 'null') {
          this.rowSpanFormatData(this.sortData)
          this.sequenceOrder = 'null'
        }
      } else if (colData === 'reach') { // 点击达成列
        if (flagData === 'ascending') { // 点击升序
          // 如果达成列当前为升序状态 则把表格置为初始状态
          if (this.sequenceOrder === 'reachascending') {
            this.rowSpanFormatData(this.sortData)
            this.sequenceOrder = 'null'
          } else {
            setTimeout(() => {
              $('.active-thead .sort-caret.ascending').css({'borderBottomColor': '#409eff'}) // 升序箭头高亮
            }, 200)
            // 把数组按照达成额升序排序
            this.reachRealignArr(this.sortData, true)
            this.sequenceOrder = 'reachascending'
          }
        } else if (flagData === 'descending') {
          if (this.sequenceOrder === 'reachdescending') {
            this.rowSpanFormatData(this.sortData)
            this.sequenceOrder = 'null'
          } else {
            setTimeout(() => {
              $('.active-thead .sort-caret.descending').css({'borderTopColor': '#409eff'})
            }, 200)
            // 把数组按照达成额降序排序
            this.reachRealignArr(this.sortData, false)
            this.sequenceOrder = 'reachdescending'
          }
        } else if (flagData === 'null') {
          this.rowSpanFormatData(this.sortData)
          this.sequenceOrder = 'null'
        }
      } else if (colData === 'proportion') { // 点击占比列
        if (flagData === 'ascending') { // 升序
          // 如果当前为升序恢复初始状态
          if (this.sequenceOrder === 'proascending') {
            this.rowSpanFormatData(this.sortData)
            this.sequenceOrder = 'null'
          } else {
            setTimeout(() => {
              $('.active-thead .sort-caret.ascending').css({'borderBottomColor': '#409eff'})
            }, 200)
            // 把获取到的表格数据先按机构分组 然后在每个分组内按照占比升序排列 然后把分组数据重新排列成数组
            this.sortData = this.realignSortArr(this.proportionRealignArr(this.dealSortArr(this.sortData), true))
            this.rowSpanFormatData(this.sortData) // 合并单元格
            this.sequenceOrder = 'proascending'
          }
        } else if (flagData === 'descending') { // 降序
          if (this.sequenceOrder === 'prodescending') {
            this.rowSpanFormatData(this.sortData)
            this.sequenceOrder = 'null'
          } else {
            setTimeout(() => {
              $('.active-thead .sort-caret.descending').css({'borderTopColor': '#409eff'})
            }, 200)
            // 把获取到的表格数据先按机构分组 然后在每个分组内按照占比降序排列 然后把分组数据重新排列成数组
            this.sortData = this.realignSortArr(this.proportionRealignArr(this.dealSortArr(this.sortData), false))
            this.rowSpanFormatData(this.sortData)
            this.sequenceOrder = 'prodescending'
          }
        } else if (flagData === 'null') {
          this.rowSpanFormatData(this.sortData)
          this.sequenceOrder = 'null'
        }
      }
    },
    handleTheadAddClass (column) {
      // 判断找到当前列添加样式
      if (column.column.property === this.curThead) {
        return 'active-thead'
      }
    },
    getType () {
      if (this.$store.state.screens.riskType !== '') {
        let getTypeData = this.$store.state.screens.riskType
        this.typeLengthArr = getTypeData.split(',')
        this.typeLength = this.typeLengthArr.length
      } else {
        this.typeLengthArr = []
        for (let i = 0; i < this.typeData.length; i++) {
          this.typeLengthArr.push(this.typeData[i].code)
        }
        this.typeLength = this.typeLengthArr.length
      }
    },
    // 把数据拆分成组
    dealSortArr (sortData) {
      // var result = []
      // var chunk = this.typeLength // 每一个机构分一组
      // for (var i = 0, j = sortData.length; i < j; i += chunk) {
      //   result.push(sortData.slice(i, i + chunk))
      // }
      // return result
      var result = []
      let cutFlag = 0
      for (let i = 0; i <= sortData.length; i++) {
        if (i < sortData.length - 1 && sortData[i].orgName === sortData[i + 1].orgName) {
        } else {
          result.push((sortData.slice(cutFlag, i + 1)))
          cutFlag = i + 1
        }
        if (i === sortData.length - 1) {
          return result
        }
      }
    },
    // 把拆分成组的数据重新排列成数组
    realignSortArr (sortData) {
      let newArr = []
      for (let i = 0; i < sortData.length; i++) {
        for (let j = 0; j < sortData[i].length; j++) {
          newArr.push(sortData[i][j])
        }
      }
      return newArr
    },
    // 对每一类别的占比排序 返回整个数组
    proportionRealignArr (sortData, order) {
      if (order) {
        for (let i = 0; i < sortData.length; i++) {
          sortData[i].sort((a, b) => a.proportion - b.proportion)
        }
      } else {
        for (let i = 0; i < sortData.length; i++) {
          sortData[i].sort((a, b) => b.proportion - a.proportion)
        }
      }
      return sortData
    },
    // 把数组按照达成额排序
    reachRealignArr (sortData, order) {
      let realignedArr = []
      for (let i = 0; i < this.typeLength; i++) {
        var typeArr = []
        for (let j = 0; j < sortData.length; j++) {
          if (sortData[j].riskTypeCode === this.typeLengthArr[i]) {
            typeArr.push(sortData[j])
          }
        }
        realignedArr[i] = typeArr
        realignedArr[i].sort((a, b) => a.reach - b.reach)
        if (!order) {
          realignedArr[i].reverse()
        }
      }
      realignedArr = this.realignSortArr(realignedArr)
      let arr = []
      this.showTabledata = JSON.parse(JSON.stringify(arr))
      this.showData = JSON.parse(JSON.stringify(arr))
      this.popData = JSON.parse(JSON.stringify(arr))
      this.rowSpanFormatData(realignedArr, true)
    },
    getHomeInfo (filter, hasAdd = false) {
      this.loadFlag = true
      let storeValue = {
        'screenOrg': this.$store.state.screens.screenOrg || '', // 机构筛选
        // 'riskType': this.$store.state.screens.riskType, // 类型筛选
        'reachStart': this.$store.state.screens.reachStart, // 达成范围起
        'reachEnd': this.$store.state.screens.reachEnd, // 达成范围止
        'proportionStrat': this.$store.state.screens.proportionStrat, // 占比范围起
        'proportionEnd': this.$store.state.screens.proportionEnd // 占比范围止
      }
      if (this.postQuota === 'A0201-1002' || this.postQuota === 'A0202-1013' || this.postQuota === 'A0202-1023') {
        storeValue.riskType = this.$store.state.screens.riskType
      } else {
        storeValue.riskType = this.$store.state.screens.period
      }
      let postDataParam = {
        'drillFlag': 0,
        'analyType': 2, // 分析类型, 1为机构分析,2 为结构分析, 3为 产品分析, 4为银行渠道分析, 5为百强中支
        'channelId': this.postChannel, // 渠道ID
        'classification': this.postKind, // 类ID
        'date': this.dateData || '', // 日期数据
        'dateType': this.timeIndex || '', // 日1 月2 年3
        'indexId': [this.postQuota],
        'key': '', // 主键
        'level': this.$store.state.user.level, // 层级
        'orgId': this.$store.state.user.orgId, // 机构ID
        'rank': 1, // 指标顺序排序
        'type': 1 // 请求类型, 1为总列表,2 为百强分支总列表, 3为 下级列表
      }
      let postData = postDataParam
      if (filter) {
        postData = {...postDataParam, ...storeValue}
      } else {
        this.$store.state.screens.riskType = '' // 类型筛选
        this.$store.state.screens.period = '' // 年期
        this.$store.state.screens.saleProduct = '' // 主销产品
        this.$store.state.screens.proportionEnd = '' // 占比范围止
        this.$store.state.screens.proportionStrat = '' // 占比范围起
        this.$store.state.screens.reachEnd = '' // 达成范围止
        this.$store.state.screens.reachStart = '' // 达成范围起
        this.$store.state.screens.screenOrg = '' // 机构筛选
      }
      if (this.dateData && this.dateData !== '') {
        this.getData = postAction('/simpapp/structuralAnalysis/tabDataHis', postData)
      } else {
        this.getData = postAction('/simpapp/structuralAnalysis/tabData', postData)
      }
      return this.getData.then((res) => {
        const tableData = []
        this.totalRows = []
        res.data.tableData.forEach(row => {
          if (row.isTotalLine === '1') {
            this.totalRows.push(row)
          } else {
            tableData.push(row)
          }
        })
        this.tableDataAny = res.data.tableData
        this.tableData = tableData
        this.nameData = res.data.headerData
        this.typeData = res.data.typeData
        this.getType()
        this.showTabledata = JSON.parse(JSON.stringify(tableData))
        // this.showData = res.data.tableData
        if (hasAdd) {
          this.rowSpanFormatData(this.tableDataAny)
        } else {
          this.rowSpanFormatData(this.showTabledata)
        }
        this.changeTable()
        this.childShow = false
        this.loadFlag = false
      })
    },
    /*
    * 通过机构名称分解数组然后遍历数组中每个中文进行解析code
    * 再将每个code累加返回出去
    */
    getCharCode (orgName) {
      let nameArr = orgName.split('')
      let num = 0
      for (let i = 0; i < nameArr.length; i++) {
        num += Number(nameArr[i].charCodeAt())
      }
      return num
    },
    /*
    * 表格数据加载前对数据进行格式化处理
    */
    rowSpanFormatData (json, flag) {
      /*
      * 给json数据进行排序，把相同字段名称的机构放在一起
      * 此方法通过遍历机构中的中文名称的code码累加值进行排序
      * 后期如果返回数据是已经排好序的数据此段代码可注释掉
      */
      // if (json && json.length) {
      //   json.sort((r1, r2) => {
      //     let charCode1 = this.getCharCode(r1.orgName)
      //     let charCode2 = this.getCharCode(r2.orgName)
      //     return charCode1 - charCode2
      //   })
      // }
      /*
       * 通过倒序遍历将循环中的数据相同的字段名称增加rowspan
       * 只给最后末尾的增加
       */
      let j = 1
      for (let i = json.length - 1; i >= 0; i--) {
        // 每次相同就让j++要是最后i==0 直接赋值就可以了
        if (i > 0 && json[i].orgName === json[i - 1].orgName) {
          j++
          delete json[i].rowspan
          // 每次不同需要就可以赋值给rowspan字段了
        } else {
          json[i].rowspan = j
          j = 1
        }
        if (flag) {
          delete json[i].rowspan
          json[i].rowspan = 1
        }
      }
      this.showTabledata = json
      this.showData = json
      this.popData = json
    },
    // 合并列的方法此方法为element中方法
    objectSpanMethod ({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        if (row.rowspan && row.rowspan > 1) {
          return { // 需要合并的行数
            rowspan: row.rowspan,
            colspan: 1
          }
        } else if (!row.rowspan) {
          return { // 当没有rowspan字段的行合并空行会去掉原本的相同字段名称
            rowspan: 0,
            colspan: 0
          }
        }
      }
    },
    load (tree, treeNode, resolve) {
      if (this.pageNum !== 0) {
        this.pageNum++
      }
      this.isInto = true
      this.loadFlag = true
      if (treeNode.loaded === false && treeNode.expanded === true) {
        this.$refs.structureTable1.toggleRowExpansion(tree, false)
        this.$refs.structureTable2.toggleRowExpansion(tree, false)
        treeNode.loading = false
        return
      }
      let treeData = []
      let childPostData = {
        'drillFlag': 1,
        'analyType': 2, // 分析类型, 1为机构分析,2 为结构分析, 3为 产品分析, 4为银行渠道分析, 5为百强中支
        'channelId': this.postChannel, // 渠道ID
        'classification': this.postKind, // 类ID
        'date': this.dateData || '', // 日期数据
        'dateType': this.timeIndex || '', // 日1 月2 年3
        'indexId': [this.postQuota],
        'key': '', // 主键
        'level': tree.nextLevel, // 层级
        'orgId': tree.orgCode, // 机构ID
        'rank': 1, // 指标顺序排序
        'type': 1, // 请求类型, 1为总列表,2 为百强分支总列表, 3为 下级列表
        'screenOrg': tree.orgCode, // 机构ID
        'screenOrgNext': this.$store.state.screens.screenOrg || '', // 机构筛选
        // 'riskType': this.$store.state.screens.riskType,
        'reachStart': this.$store.state.screens.reachStart || '',
        'reachEnd': this.$store.state.screens.reachEnd || '',
        'proportionStrat': this.$store.state.screens.proportionStrat || '',
        'proportionEnd': this.$store.state.screens.proportionEnd || ''
      }
      if (this.postQuota === 'A0201-1002' || this.postQuota === 'A0202-1013' || this.postQuota === 'A0202-1023') {
        childPostData.riskType = this.$store.state.screens.riskType
      } else {
        childPostData.riskType = this.$store.state.screens.period
      }
      if (this.dateData && this.dateData !== '') {
        this.getData = postAction('/simpapp/structuralAnalysis/tabDataHis', childPostData)
      } else {
        this.getData = postAction('/simpapp/structuralAnalysis/tabData', childPostData)
      }
      this.getData.then((res) => {
        treeData = res.data.tableData
        this.childTable = treeData
        // this.tableData = JSON.parse(JSON.stringify(treeData))
        this.showData = JSON.parse(JSON.stringify(treeData))
        this.rowSpanFormatData(this.showData)
        this.childShow = true
        treeNode.loaded = false // 加载完成后将加载状态置为 false
        this.loadFlag = false
        // resolve(treeData) // 进行数据加载
      })
    },
    closeExpanded () {
      for (let i = 0; i < this.showData.length; i++) {
        try {
          this.$refs.structureTable1.toggleRowExpansion(this.showData[i], false)
          if (this.isShow) {
            this.$refs.structureTable2.toggleRowExpansion(this.showData[i], false)
          }
        } catch (err) {
        }
      }
    },
    childByValue (childValue, closeFlag) {
      // childValue就是子组件传过来的值
      if (!closeFlag) {
        this.getHomeInfo(true)
      }
      this.show = childValue
      this.closeExpanded()
    },
    showPopup () {
      this.show = true
    },
    showMore () {
      if (this.$store.state.user.level === '1') {
        this.popData = this.totalRows.concat(JSON.parse(JSON.stringify(this.showTabledata)))
      } else {
        this.popData = JSON.parse(JSON.stringify(this.showTabledata))
      }
      this.rowSpanFormatData(this.popData)
      this.isShow = true
      this.pageNum = 1
      // this.childShow = false
      this.sequenceOrder = 'null'
      // if (this.showTabledata.length > 5) {
      //   if (this.moreText === '查看更多') {
      //     this.moreText = '收起'
      //     this.showData = this.showTabledata
      //   } else {
      //     this.moreText = '查看更多'
      //     this.showData = this.listData
      //   }
      // }
    },
    back () {
      this.pageNum = 0
      this.isInto = false
      this.isShow = false
      this.sequenceOrder = 'null'
      // this.getHomeInfo(true)
      if (this.$store.state.user.level !== '1') {
        this.rowSpanFormatData(this.tableData)
      } else if (this.$store.state.user.level === '1' && !this.childShow) {
        this.rowSpanFormatData(this.tableData)
      } else {
        this.rowSpanFormatData(this.childTable)
      }
      this.closeExpanded()
      $(document.body).css({
        'overflow-y': 'auto'
      })
    },
    // 返回
    backMore (flag = false) {
      this.isInto = false
      this.sequenceOrder = 'null'
      if (flag) {
        if (this.$store.state.user.level !== '1' && this.pageNum === 0) {
          this.rowSpanFormatData(this.tableData)
        } else if (this.$store.state.user.level === '1' && this.childShow) {
          this.rowSpanFormatData(this.tableData)
        } else {
          this.rowSpanFormatData(this.childTable)
        }
      } else {
        // 总公司且在查看更多页面显示合计行
        if (this.pageNum === 2 && this.$store.state.user.level === '1') {
          this.rowSpanFormatData(this.totalRows.concat(this.tableData))
        } else {
          this.rowSpanFormatData(this.tableData)
        }
      }
      // 如果是在查看更多下钻页面 返回 显示合计行
      if (this.pageNum === 2) {
        this.pageNum = 1
      } else {
        this.pageNum = 0
      }
      this.closeExpanded()
      this.changeTable()
      this.childShow = false
      this.loadFlag = false
    },
    changeTable () {
      this.moreText = '查看更多'
      // this.popData = JSON.parse(JSON.stringify(this.showData))
      // this.listData = []
      // if (this.showTabledata.length > 5) {
      //   this.moreFlag = true
      //   for (let i = 0; i < 5; i++) {
      //     this.listData.push(this.showTabledata[i])
      //   }
      //   this.showData = this.listData
      // } else {
      //   this.moreFlag = false
      //   this.showData = this.showTabledata
      // }
    }
  },
  mounted () {
    try {
      this.$refs.screen.clearSelectedBranchs()
    } catch (err) {
    }
    this.postChannel = this.$store.state.entirety.channel
    this.postKind = this.$store.state.entirety.kind
    this.postQuota = this.$store.state.entirety.quota
    this.popHeight = document.documentElement.clientHeight - 40
    if (this.timeIndex) {
      if (this.$store.state.entirety.quotaName.length <= 6) {
        this.tableHeight = 'calc(100vh - 202px)'
      } else {
        this.tableHeight = 'calc(100vh - 212px)'
      }
      this.getHomeInfo()
    }
  },
  watch: {
    timeIndex () {
      this.$nextTick(() => {
        if (this.timeIndex === 2) {
          this.tableHeight = 'calc(100vh - 217px)'
          if (this.$store.state.entirety.quotaName.length <= 6) {
            this.tableHeight = 'calc(100vh - 202px)'
          } else {
            this.tableHeight = 'calc(100vh - 212px)'
          }
        } else {
          this.tableHeight = 'calc(100vh - 225px)'
          if (this.$store.state.entirety.quotaName.length <= 6) {
            this.tableHeight = 'calc(100vh - 225px)'
          } else {
            this.tableHeight = 'calc(100vh - 242px)'
          }
        }
        try {
          this.$refs.screen.clearSelectedBranchs()
        } catch (err) {
        }
        this.closeExpanded()
        this.getHomeInfo()
      })
    },
    dateData () {
      this.$nextTick(() => {
        try {
          this.$refs.screen.clearSelectedBranchs()
        } catch (err) {
        }
        this.closeExpanded()
        this.getHomeInfo()
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
  >>>table.el-table__header{
    width: 100%;
  }
  >>>table.el-table__body{
    width: 100%;
  }
  /deep/.el-table__row{
    width: 100%;
    height: 0.53rem;
  }
  >>>.tableList5{
    // max-height: 4.65rem;
    overflow: hidden;
    margin-bottom: 0.4rem
  }
  .table {
    position: relative;
  }
  .table-warpper{
    margin-top: 0.1rem;
    padding: 0px 15px;
    background: #fff;
  }
  .table-itme>>>.el-table__expand-icon{
    float : left;
  }
  .table-itme>>>td,.table-itme>>>th{
    // border-right: none;
    text-align : center;
  }
  .table-itme>>>span.el-table__indent{
    padding-left : 0!important;
  }
  .table-itme>>>tr.el-table__row.el-table__row--level-1{
    background : #F9F9F9;
  }
  .table-itme>>>.el-table__expand-icon{
    margin-right: -25px;
  }
  // .table-itme>>>tr.el-table__row.el-table__row--level-1:nth-child(0) .cell{
  //   margin-right: 20px
  // }
  .table-itme>>>span.el-table__placeholder{ // 不同级别缩进相同(不分等级级别对齐)
    width : 0;
  }
  .table-itme>>>tr.el-table__row.el-table__row--level-2 {
      background: #eee;
  }
  .van-popup.van-popup--center{
    width : 90%;
    // height : 60%;
    border-radius : .06rem;
    background #fff;
  }
  .table-title,.table-icon{
    font-size: 0.18rem;
    font-weight: 600;
    height: 0.45rem;
    line-height: 0.45rem;
  }
  .table-title1{
    font-size: 0.14rem;
    height: 0.34rem;
    margin-bottom:0.1rem
  }
  .table-icon{
    text-align : right;
  }
  .table-itme>>>.el-table__expanded-cell{
    padding: 0;
    padding-left: 48px;
  }
  .table-itme>>>.el-form--inline .el-form-item__content{
    padding-left: 4px;
    padding-right: 4px;
  }
  .table-itme>>>.cell{
    padding-left: 4px !important;
    padding-right: 4px !important;
  }
  .table-itme>>>td.el-table__expanded-cell{
    background: #F9F9F9;
  }
  .demo-table-expand {
    font-size: 0;
  }
  .demo-table-expand label {
    width: 90px;
    color: #99a9bf;
  }
  .demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 50%;
  }
  .demo-table-expand{
    display: flex;
  }
  .more{
    width:100%;
    line-height:.4rem;
    text-align: center;
    color:#3399FF;
    background: #ffffff;
    font-size: .14rem;
    border-bottom: 1px solid #EBEEF5;
    position:fixed;
    bottom:0
  }
  .changeColor{
    color:#3399FF;
    font-size: .18rem
  }
  .table-title1 div{
    height: 0.34rem;
    display:table-cell;
    vertical-align:bottom
  }
  .fixTop{
    width:100%;
    height:100vh;
    position : fixed;
    top:0;
    left:0;
    right:0;
    bottom:0;
    z-index:999999999;
  }
  >>>colgroup{
    overflow: hidden;
    display: none;
  }
  .showImg{
    position flex
    z-index 999999999999999
  }
</style>



// WEBPACK FOOTER //
// src/pages/entirety/components/BankStructureTable.vue